<template>
  <fccModal
    idModal="modal-texto-padrao"
    :titleModal="titleModal"
    centered
    escondeFooter
    travaEsc
    travaBack
    size="xl"
  >
    <div class="card pt-2">
      <b-tabs>
        <b-tab title="Título"><fcc-titulo v-model="titulo" /></b-tab>
        <b-tab title="Documentos necessários para prestação de provas"
          ><fcc-documentos-necessarios v-model="documentosNecessarios"
        /></b-tab>
        <b-tab title="Observação"><fcc-observacao v-model="observacao" /></b-tab>
        <b-tab title="Aviso"><fcc-aviso v-model="aviso" /></b-tab>
      </b-tabs>
    </div>

    <div class="text-right mt-3"><fcc-button @click="aplicarMensagens">Adicionar</fcc-button></div>
  </fccModal>
</template>
<script>
import FccTitulo from './fccTitulo.vue'
import FccDocumentosNecessarios from './fccDocumentosNecessarios.vue'
import FccObservacao from './fccObservacao.vue'
import FccAviso from './fccAviso.vue'
import axios from 'axios'
import fccStore from '@/store'

export default {
  components: {
    FccTitulo,
    FccDocumentosNecessarios,
    FccObservacao,
    FccAviso
  },
  props: {
    payloadBase: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      titleModal: 'Texto Padrão',
      titulo: '',
      documentosNecessarios: '',
      observacao: '',
      aviso: ''
    }
  },
  methods: {
    aplicarMensagens() {
      this.callConfirm(
        'Adicionar mensagens',
        'Desejar adicionar os textos para as opções marcadas?'
      ).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))

          Promise.all([
            this.adicionaMensagemTitulo(),
            this.adicionaMensagemDocApresentacao(),
            this.adicionaMensagemObservacao(),
            this.adicionaMensagemAviso()
          ]).then(() => {
            this.carregaTexto()
            this.callToast('Mensagens adicionadas', 'success')
            this.$root.$emit('bv::hide::modal', 'modal-texto-padrao')
          })
        }
      })
    },
    adicionaMensagemTitulo() {
      return new Promise((resolve) => {
        const payload = {
          ...this.payloadBase,
          titulo: this.titulo
        }

        axios
          .post(
            fccStore.state.baseUrlLocalDeProva + `LocalExameApresentacao/AdicionaMensagemTitulo`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
          .catch(this.setErrorSystem)

        resolve()
      })
    },
    adicionaMensagemDocApresentacao() {
      return new Promise((resolve) => {
        const payload = {
          ...this.payloadBase,
          docApresentacao: this.documentosNecessarios
        }

        axios
          .post(
            fccStore.state.baseUrlLocalDeProva +
              `LocalExameApresentacao/AdicionaMensagemDocApresentacao`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
          .catch(this.setErrorSystem)
      })
    },
    adicionaMensagemObservacao() {
      return new Promise((resolve) => {
        const payload = {
          ...this.payloadBase,
          observacao: this.observacao
        }

        axios
          .post(
            fccStore.state.baseUrlLocalDeProva +
              `LocalExameApresentacao/AdicionaMensagemObservacao`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
          .catch(this.setErrorSystem)
      })
    },
    adicionaMensagemAviso() {
      return new Promise((resolve) => {
        const payload = {
          ...this.payloadBase,
          aviso: this.aviso
        }

        axios
          .post(
            fccStore.state.baseUrlLocalDeProva + `LocalExameApresentacao/AdicionaMensagemAviso`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
          .catch(this.setErrorSystem)
      })
    }
  }
}
</script>